export interface HourMeterRequest {
  userEmail: string;
  meter: number | null;
}
